import { FarmNftItemV3 } from "./FarmNftItemV3";
import { FarmNftMinterV3 } from "./FarmNftMinterV3";

export const FARM = {
  NftItem: FarmNftItemV3,
  NftMinter: FarmNftMinterV3,
} as const;
